/* <gw-waitlist-modal> — opens its native <dialog> when a link to the trigger
   hash (data-trigger, e.g. "#gw-waitlist") is clicked anywhere on the page.
   Also opens on load when the URL already carries the trigger hash, when
   Shopify has just returned from the sign-up form (data-gw-wl-posted inside:
   thank-you or errors), or in the theme editor preview (data-open).
   Closes on the X / Close buttons, a click on the backdrop and Escape (native).
   Focus is trapped and restored by <dialog>.showModal(). */
if (!customElements.get('gw-waitlist-modal')) {
  window.wetheme && window.wetheme.webcomponentRegistry &&
    window.wetheme.webcomponentRegistry.register({ key: 'gw-waitlist-modal' });

  class GwWaitlistModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.trigger = this.getAttribute('data-trigger') || '#gw-waitlist';
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onClosed = this.onClosed.bind(this);

      document.addEventListener('click', this.onDocumentClick);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('close', this.onClosed);

      if (
        this.hasAttribute('data-open') ||
        this.querySelector('[data-gw-wl-posted]') ||
        window.location.hash === this.trigger
      ) {
        this.open();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onDialogClick);
        this.dialog.removeEventListener('close', this.onClosed);
      }
    }

    onDocumentClick(event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || link.getAttribute('href') !== this.trigger) return;
      event.preventDefault();
      this.open();
    }

    onDialogClick(event) {
      /* A click on the backdrop lands on the <dialog> itself, not its content. */
      if (event.target === this.dialog || event.target.closest('[data-gw-wl-close]')) {
        this.dialog.close();
      }
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add('gw-waitlist-modal-open');
    }

    onClosed() {
      document.documentElement.classList.remove('gw-waitlist-modal-open');
      /* Drop ?customer_posted=true so a refresh does not reopen the thank-you. */
      if (window.location.search.indexOf('customer_posted') !== -1 && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname);
      }
    }
  }

  customElements.define('gw-waitlist-modal', GwWaitlistModal);
}
